import { Button, Group, Image, rem } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import {
  IconApps,
  IconBuilding,
  IconHeadset,
  IconLogout,
  IconSettings,
} from "@tabler/icons-react";
import { AppResources, AppRoutes } from "@/constants";
import { openSupportTab } from "@pages/TaxProHome/supportUtil.ts";
import { showIntercom } from "@/utils/intercom";
import { useAuthStore } from "@utils/stores/authStore.ts";
import { openNewTab } from "@/utils/browserUtils";
import { getIntakeServiceBureauHomeUrl } from "@/utils/intakeUrl";

type LiteTopNavbarProps = {
  onLogout?: () => Promise<void> | void;
  onSettingsClick?: () => void;
  onHomeClick?: () => void;
  hideSettings?: boolean;
};

const LiteTopNavbar = ({
  onLogout,
  onSettingsClick,
  onHomeClick,
  hideSettings = false,
}: LiteTopNavbarProps) => {
  const navigate = useNavigate();
  const isServiceBureauUser = useAuthStore((s) => s.isServiceBureauUser);

  const handleSettings = () => {
    if (onSettingsClick) {
      onSettingsClick();
      return;
    }
    navigate(AppRoutes.homeLite);
  };
  const handleHome = () => {
    if (onHomeClick) {
      onHomeClick();
      return;
    }
    navigate(AppRoutes.homeLite);
  };
  const handleLogout = async () => {
    if (onLogout) await onLogout();
    navigate(AppRoutes.logout);
  };

  const handleOpenIntercom = () => {
    showIntercom();
  };

  return (
    <Group
      justify="space-between"
      align="center"
      p={rem(12)}
      wrap="wrap"
      style={{
        background: "#FFFFFF",
        boxSizing: "border-box",
        minHeight: rem(56),
      }}
    >
      <Group gap={rem(8)} style={{ flexShrink: 0 }}>
        <Image
          src={AppResources.logo}
          alt="SmartWiz"
          h={25}
          w={141}
          fit="contain"
          onClick={handleHome}
          style={{ cursor: "pointer" }}
        />
      </Group>

      <Group gap={rem(12)} wrap="nowrap" style={{ flexShrink: 1 }}>
        <Button
          variant="subtle"
          color="#1E1E1E"
          leftSection={<IconApps size={16} color="#1E1E1E" />}
          onClick={openSupportTab}
          styles={{
            root: { paddingInline: rem(8) },
          }}
        >
          SmartHub
        </Button>
        <Button
          variant="subtle"
          color="#1E1E1E"
          leftSection={<IconHeadset size={16} color="#1E1E1E" />}
          onClick={handleOpenIntercom}
          styles={{
            root: { paddingInline: rem(8) },
          }}
        >
          Support
        </Button>
        {isServiceBureauUser() && (
          <Button
            variant="subtle"
            color="#1E1E1E"
            leftSection={<IconBuilding size={16} color="#1E1E1E" />}
            onClick={() => openNewTab(getIntakeServiceBureauHomeUrl())}
            styles={{
              root: { paddingInline: rem(8) },
            }}
          >
            Service bureau
          </Button>
        )}
        {!hideSettings && (
          <Button
            variant="subtle"
            leftSection={<IconSettings size={16} color="#1E1E1E" />}
            onClick={handleSettings}
            color="#1E1E1E"
            styles={{
              root: { paddingInline: rem(8) },
            }}
          >
            Settings
          </Button>
        )}
        <Button
          variant="subtle"
          leftSection={<IconLogout size={16} color="#0077CC" />}
          styles={{
            label: { fontWeight: 500, fontSize: rem(14), color: "#0077CC" },
            root: { height: rem(32), paddingInline: rem(8) },
          }}
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Group>
    </Group>
  );
};

export default LiteTopNavbar;
